export const resolveRateChange = (rateChangeInput, { exposure }) => {
  if (!rateChangeInput) {
    return rateChangeInput;
  }
  let out = rateChangeInput;

  if (rateChangeInput?.layerDefaults && rateChangeInput?.byLayer) {
    out = {
      ...out,
      byLayer: Object.fromEntries(
        Object.entries(rateChangeInput.byLayer).map(([layerId, layer]) => [
          layerId,
          {
            ...rateChangeInput.layerDefaults,
            ...layer,
          },
        ])
      ),
    };
  }

  if (out.isPrimaryExposureSelectedByDefault && exposure.primaryExposure) {
    out = {
      ...out,
      byLayer: Object.fromEntries(
        Object.entries(out.byLayer).map(([layerId, layer]) => [
          layerId,
          {
            ...layer,
            selectedExposures: layer.selectedExposures ?? {
              [exposure.primaryExposure]: true,
            },
          },
        ])
      ),
    };
  }

  return out;
};
